import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { NavLink } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { addCart } from "../redux/action";
import "./Product.css";

const Product = () => {
  const { id } = useParams();
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const dispatch = useDispatch();

  const addProduct = (product) => {
    dispatch(addCart(product));
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  useEffect(() => {
    const getProduct = async () => {
      setLoading(true);
      const response = await fetch(`https://fakestoreapi.com/products/${id}`);
      const data = await response.json();
      setProduct(data);
      setLoading(false);
    };
    getProduct();
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const Loading = () => (
    <>
      <div className="col-md-6" style={{ lineHeight: 2 }}>
        <Skeleton height={400} />
      </div>
      <div className="col-md-6">
        <Skeleton height={50} width={300} />
        <Skeleton height={75} />
        <Skeleton height={25} width={150} />
        <Skeleton height={50} />
        <Skeleton height={150} />
        <Skeleton height={50} width={100} />
        <Skeleton height={50} width={100} style={{ marginLeft: 6 }} />
      </div>
    </>
  );

  const ShowProduct = () => (
    <>
      <div className="col-md-6 text-center">
        <img src={product.image} alt={product.title} height="400px" width="400px" />
      </div>
      <div className="col-md-6 product-details">
        <h4 className="product-category">{product.category}</h4>
        <h1 className="product-title">{product.title}</h1>
        <p className="product-rating">⭐ {product.rating && product.rating.rate} / 5</p>
        <h3 className="product-price">₹{product.price}</h3>
        <p className="product-description">{product.description}</p>
        <div className="product-actions">
          <button className="btn-add" onClick={() => addProduct(product)}>
            Add to Cart
          </button>
          <NavLink to="/cart" className="btn-go-cart">
            Go to Cart
          </NavLink>
        </div>
      </div>

      {showToast && <div className="toast-message">✅ Added to cart!</div>}
    </>
  );

  return (
    <div className="product-container">
      <div className="container py-5">
        <div className="row py-4">{loading ? <Loading /> : <ShowProduct />}</div>
      </div>
    </div>
  );
};

export default Product;
